import styled from 'styled-components';
import { media } from 'lib/media-queries/mixins';

export const ActivityFormWrapperContainer = styled.div`
  header,
  footer {
    display: none !important;
  }
`;

export const ActivityFormContainer = styled.div`
  margin: 0px auto;
  width: 100%;
  max-width: 800px;
  padding: 50px 20px;

  ${media.PhoneOnly`
    max-height: 100vh;
    overflow: hidden;
    overflow-y: auto;
  `}

  > h2 {
    margin-bottom: 40px;
  }
`;
